import script from "./goRinSyo0024.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0024.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0024.vue?vue&type=style&index=0&id=3de57bfa&lang=scss"

const __exports__ = script;

export default __exports__